import axios from "axios";

const FIRM_TOKEN =process.env.REACT_APP_FIRM_TOKEN
 /*  "f_secret_sandbox_9f1e34968e61a03327db39625fdc684f1cfbdcc20e9df244434c62478f0b7652"; */
const GRAPHQL_URL = "https://api.sandbox.gravity-legal.com/v2";
const CreatePaymentToken = () => {
  const query = `
  mutation {
    createPaymentToken {
      paymentToken
    }
  }
`;
  const headers = {
    "x-api-key": FIRM_TOKEN,
    "Content-Type": "application/json",
  };
  const request =axios.post(GRAPHQL_URL, { query }, { headers })
  return request
    .then((response) => {
      return response.data.data.createPaymentToken.paymentToken
    })
    .catch((error) => {
      console.error("Error:", error);
    });
};


const RunPayment = (payment) => {
   
    const query = `
  mutation RunPayment($input: RunPaymentInput!) {
    runPayment(input: $input) {
      id
      status
      transactions {
        id
        amountProcessed
      }
    }
  }
`;

const variables = {
  input: {
    amount: payment.amount,
    paymentMethod: payment.paymentMethod,
    paymentToken: payment.paymentToken,
  },
};
    const headers = {
      "x-api-key": FIRM_TOKEN,
      "Content-Type": "application/json",
    };
    const request =axios.post(GRAPHQL_URL, { query, variables }, { headers })
    return request
      .then((response) => {
         
        return response
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };
export default { CreatePaymentToken,RunPayment };
